import { create } from 'zustand';

export type ToastType = 'info' | 'success' | 'warning' | 'error';
export interface ToastItem { id: number; message: string; type: ToastType; ttlMs: number; shown?: boolean }
interface ToastState {
  toasts: ToastItem[];
  push: (message: string, type?: ToastType, ttlMs?: number) => number;
  dismiss: (id: number) => void;
  markShown: (id: number) => void;
}

let seq = 0;
export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (message, type = 'info', ttlMs = 3500) => {
    const id = ++seq;
    set((s) => ({ toasts: [...s.toasts, { id, message, type, ttlMs }] }));
    if (ttlMs > 0) setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), ttlMs);
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  markShown: (id) => set((s) => ({ toasts: s.toasts.map((t) => (t.id === id ? { ...t, shown: true } : t)) })),
}));

export const toast = {
  info: (m: string) => useToastStore.getState().push(m, 'info'),
  success: (m: string) => useToastStore.getState().push(m, 'success'),
  warning: (m: string) => useToastStore.getState().push(m, 'warning', 5000),
  error: (m: string) => useToastStore.getState().push(m, 'error', 6000),
};
